import OnboardingStore from './OnboardingStore'

export default OnboardingStore
